import { cn } from "../../../lib/cn";

type ProjectsCounterProps = {
  current: number;
  total: number;
  className?: string;
};

export function ProjectsCounter({ className, current, total }: ProjectsCounterProps) {
  return (
    <div className={cn("projects-counter", className)}>
      <span>
        {String(current + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
      </span>
    </div>
  );
}
